import { useEffect, useMemo } from "react";
import { convertElementClassToCss } from "../functions/launcherElement/convertElementClassToCss";

export function useElementCssClassName(elementId: string, elementClass: any) {
  const elementCss = useMemo(
    () => convertElementClassToCss(elementId, elementClass),
    [
      elementId,
      elementClass,
    ],
  );

  const elementCssStyleSheet = useMemo(
    () => new CSSStyleSheet(),
    [],
  );

  useEffect(
    () => {
      document.adoptedStyleSheets = [...document.adoptedStyleSheets, elementCssStyleSheet];

      return () => {
        document.adoptedStyleSheets = document.adoptedStyleSheets.filter((styleSheet) => styleSheet !== elementCssStyleSheet);
      };
    },
    [
      elementCssStyleSheet,
    ],
  );

  useEffect(
    () => {
      elementCssStyleSheet.replaceSync(elementCss.value);

      requestAnimationFrame(() => {});
    },
    [
      elementCssStyleSheet,
      elementCss.value,
    ],
  );

  return elementCss.className;
}